export default "__VITE_ASSET__B7KJUo$K__"